import styled from 'styled-components'
import { Card } from 'antd'

export const ConfigCard = styled(Card)`
	width: 100%;

	& .ant-card-extra .ant-form-item {
		margin-bottom: 0px;
		color: red;
	}
`
